module.exports = __webpack_public_path__ + "assets/CircleInOutSquareDetailed.2c50ddedc0428a6f93ea2e70971fc622.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/CircleInOutSquareDetailed.png
// module id = 486
// module chunks = 0